import './Menu.css';
import React, { useState, useRef, useEffect } from 'react';
import {NavLink} from "react-router-dom";
import SocialIconsDialog from "../share_icons/ShareIconsDialog";

function Menu() {
    const [dropdownOpen, setDropdownOpen] = useState(false);
    const [isSocialIconsDialogOpen, setSocialIconsDialogOpen] = useState(false);
    const dropdownRef = useRef(null);

    // Close dropdown when clicking outside
    useEffect(() => {
      function handleClickOutside(event) {
        if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
          setDropdownOpen(false);
        }
      }
      document.addEventListener("mousedown", handleClickOutside);
      return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    return (
        <>
            <nav className="bg-gray-800">
                <div className="mx-auto max-w-7xl px-2 sm:px-6 lg:px-8">
                    <div className="relative flex h-16 items-center justify-between">
                        <div className="flex flex-1 items-center justify-center sm:items-stretch sm:justify-start">
                            <div className="sm:ml-6 sm:block">
                                <div className="flex space-x-4">
                                    <NavLink to="/" className={`rounded-md px-3 py-2 text-sm font-medium ${({isActive}) => (isActive ? "active" : "")}`}>App</NavLink>
                                    <NavLink to="/topics" className={`rounded-md px-3 py-2 text-sm font-medium ${({isActive}) => (isActive ? "active" : "")}`}>Topics</NavLink>
                                    <NavLink to="/about" className={`rounded-md px-3 py-2 text-sm font-medium ${({isActive}) => (isActive ? "active" : "")}`}>About</NavLink>
                                </div>
                            </div>
                        </div>

                        {/* Right side dropdown */}
                        <div className="relative" ref={dropdownRef}>
                            <button
                                id="menu-dropdown-button"
                                onClick={() => setSocialIconsDialogOpen(true)}
                                className="px-3 py-2 mr-3 rounded-md text-sm font-medium focus:outline-none"
                            >
                                <svg 
                                    id="menu-dropdown-svg"
                                    className="stroke-gray-300"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 32 32"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z"
                                    />
                                </svg>
                            </button>

                            <button
                                id="menu-dropdown-button"
                                onClick={() => setDropdownOpen((prev) => !prev)}
                                className="px-3 py-2 rounded-md text-sm font-medium focus:outline-none"
                            >
                                <svg 
                                    id="menu-dropdown-svg"
                                    className="stroke-gray-300"
                                    xmlns="http://www.w3.org/2000/svg"
                                    fill="none"
                                    viewBox="0 0 32 32"
                                    strokeWidth="1.5"
                                    stroke="currentColor"
                                >
                                    <path
                                        strokeLinecap="round"
                                        strokeLinejoin="round"
                                        d="M19.5 14.25v-2.625a3.375 3.375 0 0 0-3.375-3.375h-1.5A1.125 1.125 0 0 1 13.5 7.125v-1.5a3.375 3.375 0 0 0-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 0 0-9-9Z"
                                    />
                                </svg>
                            </button>
                            {dropdownOpen && (
                                <div className="doc-dropdown absolute right-0 mt-2 w-48 bg-gray-800 rounded-md shadow-lg py-1 z-20">
                                    <NavLink
                                        to="/terms"
                                        className="doc-link block px-4 py-2 text-sm"
                                    >
                                        Terms & Conditions
                                    </NavLink>
                                    <NavLink
                                        to="/privacy"
                                        className="doc-link block px-4 py-2 text-sm"
                                    >
                                        Privacy Policy
                                    </NavLink>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </nav>
            {isSocialIconsDialogOpen && <SocialIconsDialog onClose={() => setSocialIconsDialogOpen(false)} />}
        </>
    );
}

export default Menu;
